import React from "react";
import Button from "../../shared/Button";
import { useInstanceStore } from "../../../store/useInstanceStore";
import { useFilterStore } from "../../../store/filterStore";

interface Props {
  loading: boolean;
  total: number;
  selected: number;
  onSelectAll: () => void;
}

const TableHeaderInfo: React.FC<Props> = ({
  loading,
  total,
  selected,
  onSelectAll,
}) => {
  const { providerType, setProviderType,toggleDropdown } = useInstanceStore();
  const setRegion = useFilterStore((state) => state.setRegion);
  const setPricingModel = useFilterStore((state) => state.setPricingModel);
  const setOperatingSystem = useFilterStore(
    (state) => state.setOperatingSystem
  );
  const setCpuArchitecture = useFilterStore((state) => state.setCpuArchitecture);
  

  return (
    <div className="flex items-center justify-between px-6 py-3 border-b border-gray-200">
      <div className="flex items-center gap-4">
        <select
          value={providerType}
          onChange={(e) => {
            setRegion("");
            setOperatingSystem("");
            setPricingModel("");
            setCpuArchitecture("");
            setProviderType(e.target.value as "aws" | "gcp" | "azure");
            toggleDropdown(-1);
          }}
          className="border border-gray-300 rounded-md text-sm px-2 py-1 text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          <option value="aws">AWS</option>
          <option value="gcp">GCP</option>
          <option value="azure">Azure</option>
        </select>

        {/* Info Text */}
        <div className="text-sm text-gray-600">
          {loading
            ? "Loading instances..."
            : `${total} Instances loaded • ${selected} selected`}
        </div>
      </div>

      {/* Right Section: Button */}
      {!loading && (
        <Button variant="light" size="md" onClick={onSelectAll}>
          {selected === total && total > 0 ? "Unselect All" : "Select All"}
        </Button>
      )}
    </div>
  );
};

export default TableHeaderInfo;
